module.exports = __webpack_public_path__ + "static/media/img1.8d7e9266.png";